var map = {
	"./EEAST/JSON/Abrrevs.json": 96,
	"./EMAS/JSON/Abrrevs.json": 99,
	"./JRCALC/JSON/Abrrevs.json": 1823,
	"./LAS/JSON/Abrrevs.json": 105,
	"./NEAS/JSON/Abrrevs.json": 108,
	"./NIAS/JSON/Abrrevs.json": 113,
	"./NWAS/JSON/Abrrevs.json": 117,
	"./SAS/JSON/Abrrevs.json": 121,
	"./SCAS/JSON/Abrrevs.json": 125,
	"./SECAMB/JSON/Abrrevs.json": 128,
	"./SJA/JSON/Abrrevs.json": 131,
	"./SWAST/JSON/Abrrevs.json": 135,
	"./WAS/JSON/Abrrevs.json": 139,
	"./WMAS/JSON/Abrrevs.json": 143,
	"./YAS/JSON/Abrrevs.json": 146
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 6269;
module.exports = webpackAsyncContext;